import { useCallback, useMemo, useState } from "react"
import { TextMatch } from "shared/text"
import { NotificationResult, useListNotification } from "interface/notification"

export const useNotificationManagementContainer = () => {
	const [searchWord, setSearchWord] = useState("")
	const [edittedNotificationList, setEdittedNotificationList] = useState<NotificationResult[] | null>(null)

	const notificationListState = useListNotification(true)
	const notificationList = useMemo(() => {
		const list = edittedNotificationList ?? notificationListState.data?.list
		if (!list) return null
		if (searchWord === '') return list
		const match = new TextMatch(searchWord)
		return list.filter((notification) => match.match(notification.title, notification.description))
	}, [notificationListState, edittedNotificationList, searchWord])

	const onAddNotification = useCallback(
		(notification: NotificationResult) => {
			const list = edittedNotificationList ?? notificationListState.data?.list
			if (!list) return
			setEdittedNotificationList([...list, notification])
		},
		[edittedNotificationList, notificationListState, setEdittedNotificationList]
	)
	const onEditNotification = useCallback(
		(notification: NotificationResult) => {
			const list = edittedNotificationList ?? notificationListState.data?.list
			if (!list) return
			setEdittedNotificationList(
				list.map((exist) => exist.notificationId === notification.notificationId ? notification : exist)
			)
		},
		[edittedNotificationList, notificationListState, setEdittedNotificationList]
	)
	const onDeleteNotification = useCallback(
		(notificationId: number) => {
			const list = edittedNotificationList ?? notificationListState.data?.list
			if (!list) return
			setEdittedNotificationList(
				list.filter((exist) => exist.notificationId === notificationId ? false : true)
			)
		},
		[edittedNotificationList, notificationListState, setEdittedNotificationList]
	)

	return useMemo(() => ({
    loading: notificationListState.loading,
    error: notificationListState.error,
    notificationList,
    searchWord,
    setSearchWord,
 		onAddNotification,
 		onEditNotification,
		onDeleteNotification,
	}), [
		notificationListState,
    notificationList,
    searchWord,
    setSearchWord,
 		onAddNotification,
		onEditNotification,
		onDeleteNotification,
	])
}